import {
  activityLogTranslation,
  ActivityLogTranslation,
} from '@/assets/locales/components/activityLog/activityLog.translation.pl.ts';
import {
  AddContactToResourceTranslation,
  addContactToResourceTranslation,
} from '@/assets/locales/components/addContactToResource/addContactToResource.translation.pl.ts';
import {
  addNoteToResourceTranslation,
  AddNoteToResourceTranslation,
} from '@/assets/locales/components/addNoteToResource/addNoteToResource.translation.pl.ts';
import {
  addTaskToResourceTranslation,
  AddTaskToResourceTranslation,
} from '@/assets/locales/components/addTaskToResource/addTaskToResource.translation.pl.ts';
import {
  announcementsTranslation,
  AnnouncementsTranslation,
} from '@/assets/locales/components/announcements/announcements.translation.pl.ts';
import {
  deleteDialogTranslation,
  DeleteDialogTranslation,
} from '@/assets/locales/components/deleteDialog/deleteDialog.translation.pl.ts';
import {
  filesTabComponentTranslation,
  FilesTabComponentTranslation,
} from '@/assets/locales/components/filesTab/filesTab.component.translation.pl.ts';
import {
  fileUploadTranslation,
  FileUploadTranslation,
} from '@/assets/locales/components/fileUpload/fileUpload.translation.pl.ts';
import {
  formTranslation,
  FormTranslation,
} from '@/assets/locales/components/form/form.translation.pl.ts';
import {
  infoPanelTranslation,
  InfoPanelTranslation,
} from '@/assets/locales/components/infoPanel/infoPanel.translation.pl.ts';
import {
  listDetailsTranslation,
  ListDetailsTranslation,
} from '@/assets/locales/components/listDetails/listDetails.translation.pl.ts';
import { TableTranslations } from '@/assets/locales/components/table/table.translations.en.ts';
import { tableTranslations } from '@/assets/locales/components/table/table.translations.pl';
import {
  taskDefinitionTranslation,
  TaskDefinitionTranslation,
} from '@/assets/locales/components/taskDefinition/taskDefinition.translation.pl.ts';
import {
  teamAnnouncementsTranslation,
  TeamAnnouncementsTranslation,
} from '@/assets/locales/components/teamAnnouncements/teamAnnouncements.translation.pl.ts';
import {
  timelineMessagesTranslations,
  TimelineMessagesTranslations,
} from '@/assets/locales/components/timelineMessages/timelineMessages.translations.pl.ts';
import {
  backButtonTranslation,
  BackButtonTranslation,
} from '@/assets/locales/components/ui/backButton/backButton.translation.pl.ts';
import {
  versionCheckerTranslations,
  VersionCheckerTranslations,
} from '@/assets/locales/components/versionChecker/versionChecker.translations.pl.ts';

import {
  addDictionaryEntryDialogTranslation,
  AddDictionaryEntryDialogTranslation,
} from './addDictionaryEntryDialog/addDictionaryEntryDialog.translation.pl';

export type ComponentsTranslation = {
  activityLog: ActivityLogTranslation;
  addContactToResource: AddContactToResourceTranslation;
  addDictionaryEntryDialog: AddDictionaryEntryDialogTranslation;
  addNoteToResource: AddNoteToResourceTranslation;
  addTaskToResource: AddTaskToResourceTranslation;
  announcements: AnnouncementsTranslation;
  backButton: BackButtonTranslation;
  deleteDialog: DeleteDialogTranslation;
  filesTab: FilesTabComponentTranslation;
  fileUpload: FileUploadTranslation;
  form: FormTranslation;
  infoPanel: InfoPanelTranslation;
  listDetails: ListDetailsTranslation;
  table: TableTranslations;
  taskDefinition: TaskDefinitionTranslation;
  teamAnnouncements: TeamAnnouncementsTranslation;
  timelineMessages: TimelineMessagesTranslations;
  versionChecker: VersionCheckerTranslations;
};

export const componentsTranslation: ComponentsTranslation = {
  activityLog: activityLogTranslation,
  addContactToResource: addContactToResourceTranslation,
  addDictionaryEntryDialog: addDictionaryEntryDialogTranslation,
  addNoteToResource: addNoteToResourceTranslation,
  addTaskToResource: addTaskToResourceTranslation,
  announcements: announcementsTranslation,
  backButton: backButtonTranslation,
  deleteDialog: deleteDialogTranslation,
  filesTab: filesTabComponentTranslation,
  fileUpload: fileUploadTranslation,
  form: formTranslation,
  infoPanel: infoPanelTranslation,
  listDetails: listDetailsTranslation,
  table: tableTranslations,
  taskDefinition: taskDefinitionTranslation,
  teamAnnouncements: teamAnnouncementsTranslation,
  timelineMessages: timelineMessagesTranslations,
  versionChecker: versionCheckerTranslations,
};
